import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";

// @material-ui/icons
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import moment from "moment";

import { DatePicker } from "@material-ui/pickers";
import { MenuItem, Select, FormControl, InputLabel } from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import MenuTypeTimetableContainer from "container/componentsCustom/MenuTypeTimetableContainer.js";
import ItemTicketType from "componentsCustom/ListItem/ItemTicketType";

import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

import styles from "./EventList.module.css";
import { Hidden } from "@material-ui/core";
import Button from "../components/CustomButtons/Button";
import getSlot from "../api/getSlot";
import { useHistory, useParams } from "react-router-dom";

const useStyles = makeStyles(menuStyle);

const Tickets = (props) => {
  const {
    updateCart,
    cart,
    language,
    museum,
    currency,
    customStyle,
    shippingInfo,
    articles,
    eventSelected,
  } = props;

  const history = useHistory();

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const { home } = useParams();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const [list, setList] = useState([]);
  const [, setCategories] = useState([]);

  // eslint-disable-next-line
  const [, setShowAddItem] = useState(false);
  const [waiting, setWaiting] = useState(false);
  // eslint-disable-next-line
  const [, setSelectedItem] = useState({});
  // eslint-disable-next-line
  const [, setShowAlert] = useState(true);
  const [slots, setSlots] = useState(null);
  const [openings, setOpenings] = useState({});
  const [dateTimeSelected, setDateTimeSelected] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  // eslint-disable-next-line
  const [showPlacesWarning, setShowPlacesWarning] = useState(false);
  const [showCartFullWarning, setShowCartFullWarning] = useState(false);
  const [isOpen] = useState("");

  const [extraordinaryClosures, setExtraordinaryClosures] = useState([]);
  const [windowSize, setWindowSize] = useState(getWindowSize());

  const [capacity, setCapacity] = useState(0);

  const [lastTimeSelected, setLastTimeSelected] = useState("");

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    setCapacity(museum.capienza_massima);
  }, [museum]);

  useEffect(() => {
    if (articles && articles[0] && articles.length > 0) {
      const categoriesArray = articles.map((el) => {
        return {
          codici_sconto: el.codici_sconto,
          id: el.id,
          nome_categoria: el.nome_categoria,
        };
      });

      setList(articles);
      setCategories(categoriesArray);
    }
  }, [articles]);

  useEffect(() => {
    if (museum.organisation && dateTimeSelected) {
      setWaiting(true);
      getSlot(
        museum.organisation.id,
        moment(dateTimeSelected).format("YYYY-MM-DD")
      )
        .then((newSlots) => {
          //If the date selected is today, list only the slots after now
          var now = new Date();
          if (dateTimeSelected > now) {
            setSlots(newSlots);
          } else {
            var i;
            var correctSlots = [];
            const hoursAndMinutes = now.getHours() + ":" + now.getMinutes();
            for (i = 0; i < newSlots.length; i++) {
              if (
                Date.parse("01/01/2022 " + newSlots[i]) >
                Date.parse("01/01/2022 " + hoursAndMinutes)
              ) {
                correctSlots.push(newSlots[i]);
              }
            }
            setSlots(correctSlots);
          }
          setWaiting(false);
        })
        .catch((err) => {
          console.log("error while requesting time", err);
        });
    }

    if (museum && museum.orari_museo) {
      setOpenings(museum.orari_museo);
    }

    if (museum && museum.chiusure_straordinarie) {
      setExtraordinaryClosures(museum.chiusure_straordinarie.split(","));
    }
  }, [dateTimeSelected, museum]);

  useEffect(() => {
    // eslint-disable-next-line
    if (shippingInfo && shippingInfo.date) {
      setShowAlert(false);
    }
  }, [shippingInfo]);

  const classes = useStyles();

  const { t } = useTranslation();

  function openSweetAlert(item, category, index, timetable) {
    setShowAddItem(true);
    setSelectedItem(
      Object.assign({}, item, { category: category, index, timetable })
    );
  }

  function addToCart(item, quantity, ingredientC, additionalKey, note) {
    const dateTime = new Date(
      dateTimeSelected.getFullYear(),
      dateTimeSelected.getMonth(),
      dateTimeSelected.getDate(),
      selectedTime.split(":")[0],
      selectedTime.split(":")[1]
    );

    const dateToAssign = moment(dateTime)
      .format("YYYY-MM-DDTHH:mm:ss")
      .toString();

    if (item && item.id) {
      if (cart && Array.isArray(cart)) {
        const copyCart = [].concat(cart);
        let maxObj = {};
        let maxNumber = 0;
        const allAdd = additionalKey.split("/");

        allAdd.forEach((element) => {
          const [, id] = element.split("_");
          const findEl =
            item && item.add && item.add.find((el) => el._id === id);

          if (findEl && findEl.maxNumber) {
            maxNumber = findEl.maxNumber;
            maxObj = Object.assign({}, maxObj, { [id]: maxNumber });
          }
        });

        if (copyCart && copyCart.length > 0) {
          const findIndexEl = cart.findIndex((el) => {
            return (
              el.productId === item.id &&
              moment(el.dateTimeSelected).isSame(dateToAssign)
            );
          });

          if (findIndexEl >= 0) {
            // SE IL BIGLIETTO ESISTE GIA'

            // SE IL BIGLIETTO ESISTE GIA' AUMENTO LA QUANTITA'
            copyCart[findIndexEl].quantity += quantity || 1;
          } else {
            // SE IL BIGLIETTO NON ESISTE LO METTO NEL CARRELLO
            copyCart.push({
              dateTimeSelected: dateToAssign,
              item: item,
              quantity: quantity,
              price: !Number.isNaN(Number(item.prezzo))
                ? Number(item.prezzo)
                : 0.0,
              productId: item.id,
              ingredientC,
              additionalKey,
              note,
              categoria_articolo: item.categoria_articolo,
              index: item.index,
              information: item.information || [],
            });
          }
        } else {
          copyCart.push({
            dateTimeSelected: dateToAssign,
            item: item,
            quantity: quantity,
            price: !Number.isNaN(Number(item.prezzo))
              ? Number(item.prezzo)
              : 0.0,
            productId: item.id,
            ingredientC,
            additionalKey,
            note,
            categoria_articolo: item.categoria_articolo,
            index: item.index,
            information: [],
          });
        }
        updateCart(copyCart);
      }
    }
  }

  function checkExtraClosures(date) {
    date.setHours(1, 0, 0, 0);

    var flag = false;

    extraordinaryClosures.forEach((closure) => {
      if (new Date(closure).getTime() === date.getTime()) {
        flag = true;
      }
    });

    return flag;
  }

  const componentsContent = (
    <CardBody style={{ marginTop: "20px" }}>
      {list && Object.keys(list) && Object.keys(list).length > 0 ? (
        <div>
          <MenuTypeTimetableContainer />
          {list.map((category) => {
            return (
              <div key={category.id}>
                <div
                  style={
                    matches && museum.delivery && museum.delivery.isListMenu
                      ? {
                          border: "solid 1px rgba(222,222,222,1)",
                          borderRadius: 10,
                          //   display: "table",
                          padding: "5px",
                          paddingBottom: "10px",
                          marginTop: "5px",
                          marginBottom: "5px",
                          width: "100%",
                        }
                      : {}
                  }
                >
                  <h1
                    className={classes.title}
                    style={{ float: "left", width: "calc(100% - 30px)" }}
                  >
                    {category.nome_categoria ? category.nome_categoria : ""}
                  </h1>
                  {matches && museum.delivery && museum.delivery.isListMenu ? (
                    <div
                      style={{
                        width: "30px",
                        textAlign: "center",
                        marginTop: "10px",
                        float: "left",
                      }}
                    >
                      {category &&
                      category.categoria_articolo &&
                      category.categoria_articolo._id === isOpen ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </div>
                  ) : null}
                </div>
                <GridContainer>
                  {category.articoli
                    ? category.articoli.map((item, ind) => {
                        if (!item.nome_articolo.includes("_DEL")) {
                          const itemToSend = {
                            disponibilita: 9999999999,
                            id: item.id,
                            nome: item.nome_articolo,
                            prezzo: item.prezzo_articolo,
                            schema_eventi: item,
                          };
                          let dateTime = null;
                          if (dateTimeSelected && selectedTime) {
                            dateTime = new Date(
                              dateTimeSelected.getFullYear(),
                              dateTimeSelected.getMonth(),
                              dateTimeSelected.getDate(),
                              selectedTime.split(":")[0],
                              selectedTime.split(":")[1]
                            );
                          }

                          const dateToAssign = moment(dateTime)
                            .format("YYYY-MM-DDTHH:mm:ss")
                            .toString();
                          itemToSend.schema_eventi.ora_inizio = dateToAssign;
                          itemToSend.museumTicket = true;
                          return (
                            <ItemTicketType
                              key={item.id}
                              item={itemToSend}
                              currency={currency}
                              language={language}
                              customStyle={customStyle}
                              category={category}
                              index={ind}
                              openSweetAlert={openSweetAlert}
                              addToCart={addToCart}
                              updateCart={updateCart}
                              cart={cart}
                              availablePlaces={capacity}
                              setShowPlacesWarning={setShowPlacesWarning}
                              dateTimeSelected={dateToAssign}
                              eventSelected={eventSelected}
                              isEvent={false}
                            />
                          );
                        }
                      })
                    : null}
                </GridContainer>
              </div>
            );
          })}
        </div>
      ) : null}
    </CardBody>
  );

  const convertDayToString = {
    0: "domenica",
    1: "lunedi",
    2: "martedi",
    3: "mercoledi",
    4: "giovedi",
    5: "venerdi",
    6: "sabato",
  };

  function checkCartQuantity(cartToCheck) {
    var totQuantity = 0;
    if (cartToCheck.length !== 0) {
      cartToCheck.forEach((element) => {
        totQuantity += element.quantity;
      });
    }
    if (totQuantity <= 7) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (!checkCartQuantity(cart)) {
      setShowCartFullWarning(true);
    } else {
      setShowCartFullWarning(false);
    }
    // eslint-disable-next-line
  }, [cart]);

  return (
    <div
      className={styles.ticketListContainer}
      style={{
        color: museum?.customizations?.eventDetailsTextColor
          ? museum?.customizations?.eventDetailsTextColor
          : "#000000",
        borderRadius: windowSize.innerWidth < 800 ? "20px" : "0",
        marginBottom: windowSize.innerWidth > 800 ? "0" : "50px",
        paddingBottom: "60px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignContent: "center",
          justifyContent: "center",
        }}
      >
        <h4>{t("buyEntranceTickets")}</h4>
        <div
          style={{
            display: "flex",
            flexDirection: windowSize.innerWidth > 800 ? "row" : "column",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: windowSize.innerWidth > 800 ? "20%" : "50%",
              marginLeft: windowSize.innerWidth > 800 ? "0" : "80px",
              marginRight: windowSize.innerWidth > 800 ? "20px" : "0",
              marginBottom: "20px",
            }}
          >
            <DatePicker
              fullWidth
              label={t("selectData")}
              value={dateTimeSelected}
              onChange={setDateTimeSelected}
              shouldDisableDate={(day) =>
                openings[convertDayToString[moment(day).format("d")]]
                  .flag_chiuso ||
                day < yesterday ||
                checkExtraClosures(day)
              }
              animateYearScrolling
              format="dd/MM/yyyy"
            />
          </div>
          {dateTimeSelected && (
            <div
              style={{
                float: "left",
                width: windowSize.innerWidth > 800 ? "20%" : "50%",
                marginLeft: windowSize.innerWidth > 800 ? "20px" : "80px",
              }}
            >
              {waiting && (
                <div
                  style={{
                    padding: "5px",
                    fontSize: "15px",
                    marginTop: "12px",
                    marginLeft: "50px",
                  }}
                >
                  <ReactLoading
                    type={"spinningBubbles"}
                    color={"#303030"}
                    height={40}
                    width={40}
                  />
                </div>
              )}
              {slots && !waiting && slots.length === 0 && (
                <div
                  style={{
                    padding: "5px",
                    fontSize: "15px",
                    marginTop: "18px",
                  }}
                >
                  {t("noResults")}
                </div>
              )}
              {slots && slots.length > 0 && (
                <div style={{ width: "100%" }}>
                  <FormControl fullWidth>
                    <InputLabel id="select-label">{t("selectTime")}</InputLabel>
                    <Select
                      label={t("selectTime")}
                      onChange={(e) => {
                        setSelectedTime(e.target.value);
                        if (e.target.value !== lastTimeSelected) {
                          setShowPlacesWarning(false);
                        }
                        setLastTimeSelected(e.target.value);
                      }}
                      value={selectedTime ? selectedTime : ""}
                    >
                      {slots.map((slot, key) => {
                        return (
                          <MenuItem key={key.toString()} value={slot}>
                            {slot}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {dateTimeSelected && selectedTime && (
        <>
          {componentsContent}

          {showPlacesWarning && (
            <p style={{ fontWeight: 700, color: "darkred" }}>
              {t("only")} {capacity}{" "}
              {capacity === 1 ? t("oneLeft") : t("fewLeft")}
            </p>
          )}
          {showCartFullWarning && (
            <p style={{ fontWeight: 700, color: "darkred" }}>{t("cartFull")}</p>
          )}
          {cart?.length > 0 && (
            <Hidden smDown implementation="css">
              <div className={styles.checkoutButtonContainer}>
                <Button
                  round={false}
                  size="sm"
                  color="lightBlue"
                  className={classes.buttonBig}
                  style={{
                    backgroundColor: customStyle.buttonAction,
                    maxWidth: "400px",
                    marginBottom: 100,
                    marginTop: 40,
                  }}
                  onClick={() =>
                    history.push(`/${museum.identificativo}/contacts/${home}`)
                  }
                >
                  <span className={classes.buttonBigText}>
                    {t("cart.checkout")}
                  </span>
                </Button>
              </div>
            </Hidden>
          )}
        </>
      )}
    </div>
  );
};

export default Tickets;
